import React, {useState} from 'react';
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";

import * as Yup from 'yup';
import { useFormik } from 'formik';
import axios from 'axios';
import Swal from 'sweetalert2';

const handleCheckCurrentPassword = async (password) => {
    let data = {}
    let userData = localStorage.getItem('FF-authUser');
    userData = JSON.parse(userData);
    if(password){
      data.id = userData.id;
      data.password = password;
      let response = await axios.post(`/api/users/checkvalidatepassword`, data)
      let result = response.data;
      if(result.success && result.exists === true){
        return true
      }
      else {
        return false
      }
    }
    else{
      return false
    }
  }
  
const validationSchema = Yup.object().shape({
oldPassword: Yup.string().required('Old Password is required')
    .test('is-valid', 'Old Password is wrong!', value => handleCheckCurrentPassword(value)),
    password: Yup.string()
    .min(8, 'New Password must be at least 8 characters')
    .required('New Password is required'),
confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Re Enter New Password is required'),
});

export default function Security() {
    const formik = useFormik({
        initialValues: {
          oldPassword: '',
          password: '',
          confirmNewPassword: '',
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
            setShowOldPassword(false)
            setShowNewPassword(false)
            setShowConfirmNewPassword(false)
            formik.resetForm(); 
        }
      });
    
    const handleSubmit = async (values) => {
    try {
        let res = await axios.post('/api/users/changepassword', values);
        if(res.data.success){
            Swal.fire(res.data.message, '', 'success')
        }
        else{
            Swal.fire(res.data.message, '', 'info')
        }
    } catch (error) {
        Swal.fire('Error', 'Failed to update password', 'error');
    }
    }

    
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

    const handleShowOldPassword = () => {showOldPassword ? setShowOldPassword(false) : setShowOldPassword(true);}
    const handleShowNewPassword = () => {showNewPassword ? setShowNewPassword(false) : setShowNewPassword(true);}
    const handleShowConfirmNewPassword = () => {showConfirmNewPassword ? setShowConfirmNewPassword(false) : setShowConfirmNewPassword(true);}

    return(
        <Layout>
        <Header pageTitle="My Profile" />
             <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-md-8">
                        <ul className="nav nav-pills flex-column flex-md-row mb-3">
                            <li className="nav-item">
                                <Link to="/profile" className="nav-link"><i className="bx bx-user me-1"></i> Account</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link active"><i className="bx bx bxs-key me-1"></i> Security</Link>
                            </li>
                        </ul>
                        <div className="card mb-4">
                            <h5 className="card-header">Change Password</h5>
                          
                            <hr className="my-0" />
                            <div className="card-body">
                                <form id="formAccountSettings" method="POST" onSubmit={formik.handleSubmit}>
                                    <div className="row">
                                        <div className="mb-3 col-md-6 form-password-toggle">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label" htmlFor="oldPassword">Old Password</label>
                                            </div>
                                            <div className="input-group input-group-merge">
                                                <input type={showOldPassword ? "text" : "password"} id="oldPassword" className="form-control" name="oldPassword" placeholder="············" aria-describedby="oldPassword" onChange={formik.handleChange}  onBlur={formik.handleChange} value={formik.values.oldPassword}/>
                                                <span className="input-group-text cursor-pointer" onClick={handleShowOldPassword}><i className={showOldPassword ? "bx bx-show" : "bx bx-hide"}></i></span>
                                            </div>
                                                {formik.touched.oldPassword && formik.errors.oldPassword && (
                                                    <div className='text-danger fs-13'>{formik.errors.oldPassword}</div>
                                                )}
                                        </div>

                                        <div className="mb-3 col-md-6 form-password-toggle">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label" htmlFor="password">New Password</label>
                                            </div>
                                            <div className="input-group input-group-merge">
                                                <input type={showNewPassword ? "text" : "password"} id="password" className="form-control" name="password" placeholder="············" aria-describedby="password" onChange={formik.handleChange}  onBlur={formik.handleChange} value={formik.values.password}/>
                                                <span className="input-group-text cursor-pointer" onClick={handleShowNewPassword}><i className={showNewPassword ? "bx bx-show" : "bx bx-hide"}></i></span>
                                            </div>
                                                {formik.touched.password && formik.errors.password && (
                                                    <div className='text-danger fs-13'>{formik.errors.password}</div>
                                                )}
                                        </div>

                                        <div className="mb-3 form-password-toggle">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label" htmlFor="confirmNewPassword">Re Enter New Password</label>
                                            </div>
                                            <div className="input-group input-group-merge">
                                                <input type={showConfirmNewPassword ? "text" : "password"} id="confirmNewPassword" className="form-control" name="confirmNewPassword" placeholder="············" aria-describedby="confirmNewPassword" onChange={formik.handleChange}  onBlur={formik.handleChange} value={formik.values.confirmNewPassword}/>
                                                <span className="input-group-text cursor-pointer" onClick={handleShowConfirmNewPassword}><i className={showConfirmNewPassword ? "bx bx-show" : "bx bx-hide"}></i></span>
                                            </div>
                                                {formik.touched.confirmNewPassword && formik.errors.confirmNewPassword && (
                                                    <div className='text-danger fs-13 mb-3'>{formik.errors.confirmNewPassword}</div>
                                                )}
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <button type="submit" className="btn btn-primary me-2">Save changes</button>
                                        {/* <button type="reset" className="btn btn-outline-secondary">Cancel</button> */}
                                    </div>
                                </form>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}